<template>
  <WhiteIQOS :enabled="true" :systemDependency="'reserve'">
    <div class="toggle-header">
      <div class="gap-row-1xs">
        <div class="qrw-heading-xs bold qrw-text-content-base-primary">
          {{ $t("reserve.allow_same_day.title") }}
        </div>
        <p class="qrw-paragraph-sm qrw-text-content-base-secondary">
          {{ $t("reserve.allow_same_day.comment") }}
        </p>
      </div>
      <BaseToggleSwitcher
        size="lg"
        fillBg="background-success-default"
        disabledBg="background-base-inverse-primary"
        :value="!allow_same_day"
        @input="onToggle"
      ></BaseToggleSwitcher>
    </div>
  </WhiteIQOS>
</template>

<script>
import IQOS from "@/components/IQOS";
import IQOSActions from "@/components/IQOSActions";

import IQOSToggle from "@/components/IQOSToggle.vue";

export default {
  data() {
    return {
      editing: false,

      allow_same_day: false,
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.resetValues();
    },
    onEditFinish() {
      this.$store.commit("setReserveSameDayAllowed", this.allow_same_day);
      this.$store.dispatch("saveCafe");

      this.editing = false;

      this.$store.dispatch("auditlog/write", {
        type: "reserve_allow_today",
        payload: {
          allow: this.allow_same_day,
        },
      });
    },
    resetValues() {
      if (this.cafe) {
        this.allow_same_day = this.cafe.reserve.allow_same_day || false;
      }
    },
    onToggle(arg) {
      this.allow_same_day = !arg;
      this.onEditFinish();
    },
  },
  mounted() {
    this.resetValues();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  components: {
    IQOS,
    IQOSActions,
    IQOSToggle,
  },
};
</script>

<style scoped>
.toggle-header {
  display: flex;
  width: 100%;
  align-items: flex-start;
  column-gap: 16px;
}
</style>
